import React from "react";
import _ from "lodash";
import moment from "moment";
import useSessionUser from "../../../hooks/useSessionUser";
import { ReactComponent as IpIcon } from "../../../assets/svg/ip-icon.svg";
import { ReactComponent as DateIcon } from "../../../assets/svg/date-icon.svg";
import { ReactComponent as LaptopIcon } from "../../../assets/svg/laptop-icon.svg";
import { ReactComponent as MobileIcon } from "../../../assets/svg/mobile-icon.svg";
import { Button } from "@material-ui/core";

const MOBILE_SESSION_OS = new Set(["Android", "iOS"]);

const isMobileSession = (row: Record<string, unknown>) => {
  const sessionOs = String(_.get(row, "session_os", ""));
  if (MOBILE_SESSION_OS.has(sessionOs)) {
    return true;
  }

  const rawInfo = _.get(row, "raw_info", "");
  if (!rawInfo) {
    return false;
  }

  try {
    const parsed =
      typeof rawInfo === "string" ? JSON.parse(rawInfo) : rawInfo;
    if (
      parsed.isMobile ||
      parsed.isiPhone ||
      parsed.isiPad ||
      parsed.isAndroid ||
      parsed.deviceOS === "android" ||
      parsed.deviceOS === "ios"
    ) {
      return true;
    }
    if (parsed.isDesktop) {
      return false;
    }
  } catch {
    return false;
  }

  return false;
};

const List = ({ data, size, handleLogout }) => {
  const { currentSession } = useSessionUser();

  return (
    <div className="session-list-grid">
      {data &&
        data.slice(0, size).map((row, index) => {
          return (
            <div
              className="session-list-item-container"
              key={index}
            >

              <div className="session-list-item-icon-wrapper">
                <div className="icon-wrapper">
                  {isMobileSession(row) ? <MobileIcon /> : <LaptopIcon />}
                </div>
              </div>
              <div className="session-list-info">
                <div className="session-list-item-content">
                  <div>
                    <div className="device-info">
                      <b>{_.get(row, "session_os", "")}  </b>
                      <span>- {_.get(row, "session_browser", "")}</span>
                    </div>
                    {_.get(row, "active_session", "") === 1 && (
                      <div className="current-session-wrapper">
                        {_.get(row, "id", "") === currentSession ? (
                          <span className="title">Current Session</span>
                        ) : (
                          <span className="title">Active Session</span>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="session-list-item-logout-wrapper">
                    {_.get(row, "id", "") !== currentSession && _.get(row, "active_session", "") === 1 && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        className="log-out"
                        onClick={() => {
                          handleLogout(_.get(row, "id", ""));
                        }}
                      >
                        Logout
                      </Button>
                    )}
                  </div>
                </div>

                <div className="ip-address-wrapper">
                  <div className="additional-info-wrapper">
                    <div className="ip-icon">
                      <IpIcon />
                    </div>
                    <span>{_.get(row, "ip_address", "")} </span>
                  </div>
                  <div className="additional-info-wrapper">
                    <div className="date-icon">
                      <DateIcon />
                    </div>
                    <span>{moment.utc(_.get(row, "created_at", "")).local().format(
                      "MMM D, YYYY h:mma"
                    )}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default List;
